import {
  FETCH_SUGGESTIONS,
  FETCH_SUGGESTIONS_SUCCESS,
  LOG_OUT_SUCCESS,
} from 'actionTypes'

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT_SUCCESS:
      return initialState
    case FETCH_SUGGESTIONS:
      return {
        ...state,
        [action.suggestionType]: {
          ...state[action.suggestionType],
          [action.value]: 'pending',
        },
      }
    case FETCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        [action.suggestionType]: {
          ...state[action.suggestionType],
          [action.value]: action.suggestions,
        },
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/suggestions.js